import { useEffect, useState } from 'react';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Assignment from '@material-ui/icons/Assignment';
import { DataGrid, GridOverlay } from '@material-ui/data-grid';
import { format } from 'date-fns';
import { sdocAdmin, admin } from 'api/index'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { useTranslation } from 'hooks/useTranslation'
import 'sweetalert2/dist/sweetalert2.min.css'

export default function SDoCTransactionsCard({
	SDoCTransactions,
	isDataLoading = false,
}) {
	const [myRole, setMyRole] = useState(null)
	const { t } = useTranslation()
	const [sortModel, setSortModel] = useState([
		{
			field: 'createDate',
			sort: 'desc',
		},
	]);
	useEffect(async () => {
		await admin.me().then(async event => {
			if (event) {
				const dataMe = event.data
				setMyRole(dataMe.roleID)
			}
		}).catch(err => {
			console.error(err)
			setMyRole(null)
		})
	}, [])


	const columnsSDoCTransactions = [
		{
			field: 'refnO1',
			headerName: t('transactionCard.colRef1'),
			width: 230,
			headerAlign: 'center',
			align: 'center',
			sortable: true,
			editable: false,
		},
		{
			field: 'refnO2',
			headerName: t('transactionCard.colRef2'),
			width: 230,
			headerAlign: 'center',
			align: 'center',
			sortable: true,
			editable: false,
		},
		{
			field: 'createDate',
			headerName: t('transactionCard.colCreateDate'),
			width: 180,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
			renderCell: (params) => (
				<Grid>
					{params.value ? format(new Date(params.value), 'dd/MM/yyyy  HH:mm') : ''}
				</Grid>
			),
		},
		{
			field: 'dueDate',
			headerName: t('transactionCard.colDueDate'),
			width: 180,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
			renderCell: (params) => (
				<Grid>
					{params.value ? format(new Date(params.value), 'dd/MM/yyyy  HH:mm') : ''}
				</Grid>
			),
		},
		{
			field: 'receiveDate',
			headerName: t('transactionCard.colReceiveDate'),
			width: 180,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
			renderCell: (params) => (
				<Grid>
					{params.value ? format(new Date(params.value), 'dd/MM/yyyy  HH:mm') : ''}
				</Grid>
			),
		},
		{
			field: 'invoiceNo',
			headerName: t('transactionCard.colInvoiceNo'),
			width: 190,
			headerAlign: 'center',
			align: 'center',
			sortable: true,
			editable: false,
		},
		{
			field: 'status',
			headerName: t('transactionCard.colStatus'),
			width: 150,
			headerAlign: 'center',
			align: 'center',
			sortable: true,
			editable: false,
			renderCell: (params) => {
				let statusText = '';
				let statusColor = '';
				var today = new Date();
				today.setDate(today.getDate() + 1);
				var dueDate = new Date(params.row.dueDate);
				if (dueDate > today && params.row.receiveDate === null && params.row.invoiceNo === null) {
					statusText = t('transactionCard.statusWaiting');
					statusColor = 'text-yellow-700';
				} else if (dueDate < today && params.row.receiveDate === null && params.row.invoiceNo === null) {
					statusText = t('transactionCard.statusExpired');
					statusColor = 'text-red-700';
				} else if (params.row.receiveDate !== null && params.row.invoiceNo === null) {
					statusText = t('transactionCard.statusPaid');
					statusColor = 'text-green-700';
				} else if (params.row.receiveDate !== null && params.row.invoiceNo !== null) {
					statusText = t('transactionCard.statusSuccess');
					statusColor = 'text-green-700';
				}

				return (
					<Grid className="flex flex-row items-center justify-center">
						<div
							className={`inline-block px-3 py-1 rounded ${statusColor}`}
							style={{ whiteSpace: 'nowrap' }}
						>
							{statusText}
						</div>
					</Grid>
				);
			}
		},
	];

	const addInvoiceNo = async () => {
		// popup from to put invoiceNo
		const SDoCID = SDoCTransactions[0].sDocID;
		const { value: invoiceNo } = await Swal.fire({
			title: t('transactionCard.addReceiptTitle'),
			input: 'text',
			inputPlaceholder: t('transactionCard.addReceiptPlaceholder'),
			showCancelButton: true,
			confirmButtonText: t('transactionCard.save'),
			cancelButtonText: t('transactionCard.cancel'),
			inputValidator: (value) => {
				if (!value) {
					return t('transactionCard.addReceiptRequired');
				}
			}
		});

		if (invoiceNo) {
			const res = await sdocAdmin.addInvoiceNo(SDoCID, invoiceNo);
			if (res.status === 200) {
				Swal.fire({
					icon: 'success',
					title: t('transactionCard.addReceiptSuccess'),
					showConfirmButton: false,
					timer: 1500
				});
				// Refresh the page or update the data
				window.location.reload();
			} else {
				Swal.fire({
					icon: 'error',
					title: t('transactionCard.errorTitle'),
					text: res.data?.message ?? t('transactionCard.errorRetry'),
					confirmButtonText: t('transactionCard.ok'),
					showConfirmButton: true,
				});
			}
		}
	}


	return (
		<Card className="border-t-4 border-card_top_border mb-5">
			<Grid className="flex flex-col justify-center items-start px-5 mb-5">
				{/* Header */}
				<Grid className="flex flex-row mt-4 mb-2">
					<Assignment style={{ fontSize: 22 }} className="mr-1" />
					<Grid className="font-bold text-sm text-card_header_color">
						{t('transactionCard.header')}
					</Grid>
				</Grid>
				<Grid className="mt-3 mb-1 w-full">
					<Divider />
				</Grid>

				{/* Files Section */}
				<Grid className="flex flex-col items-start my-2 w-full gap-y-3">
					<Grid>{t('transactionCard.details')}</Grid>
					<Grid className="md:px-5" style={{ height: 275, width: '100%' }}>
						<DataGrid
							rows={SDoCTransactions}
							columns={columnsSDoCTransactions}
							pageSize={2}
							rowsPerPageOptions={[2]}
							disableSelectionOnClick
							sortModel={sortModel}
							rowHeight={70}
							components={{
								NoRowsOverlay: () =>
									isDataLoading ? (
										<GridOverlay>{t('transactionCard.loading')}</GridOverlay>
									) : (
										<GridOverlay>{t('transactionCard.noData')}</GridOverlay>
									),
							}}
						/>
					</Grid>
				</Grid>
				<Grid className="text-xs text-card_header_color ml-1">
					{myRole == 15 ?(
						<Button
							color="primary"
							variant="contained"
							component="label"
							size="small"
							className="flex w-full"
							onClick={() => {
								// Handle the button click event here
								// Call the function to add invoice number
								addInvoiceNo();
							}}
						>
							{t('transactionCard.addReceiptBtn')}
						</Button>
					): null}
				</Grid>
				<Grid className="mt-3 mb-1 w-full">
					<Divider />
				</Grid>
			</Grid>
		</Card>
	);
}
